import React from 'react';

import {useIntl} from "react-intl";
import m from "../../definedMessages";

import { Button, Modal, Tooltip } from "rsuite";
import Whisper from "components/Whisper";
import { useModalStack } from "components/base/useModalStack";

export default ({show, onClose, onSuccess, children, title, width, successButton, closeButton, successButtonProps, showCloseSuccessButtons = true, onSuccessClose = true, style, backdropStyle, ...props}) => {
    const styles = {...style};
    width && (styles.width = width);
    const { zIndex, backdropZIndex } = useModalStack(show);
    styles.zIndex = zIndex;
    const mergedBackdropStyle = {
        ...backdropStyle,
        zIndex: backdropZIndex
    };
    const {formatMessage} = useIntl();

    const closeModal = (onClose, onSuccess) => {
        onSuccess();
        onClose();
    };
    return (
        <Modal {...props} open={show} onClose={onClose} style={styles} backdropStyle={mergedBackdropStyle}>
            <Modal.Header>
                {
                    props.whisper ?
                        <Whisper
                            placement="bottomStart"
                            trigger="hover"
                            speaker={
                                <Tooltip>
                                    {props.whisper}
                                </Tooltip>
                            }
                        >
                            <Modal.Title>{title}</Modal.Title>
                        </Whisper>
                        :
                        <Modal.Title>{title}</Modal.Title>
                }
            </Modal.Header>
            <Modal.Body style={{maxHeight: '100%'}}>
                {children}
            </Modal.Body>
            <Modal.Footer>
                {
                    (() => {
                        if (showCloseSuccessButtons) {
                            return (
                                <>
                                    <Button appearance="primary"
                                            onClick={() => {
                                                if (onSuccessClose) {
                                                    closeModal(onClose, onSuccess);
                                                } else {
                                                    onSuccess();
                                                }
                                            }} {...successButtonProps}>
                                        {successButton ? successButton : formatMessage(m.yes)}
                                    </Button>
                                    <Button onClick={onClose} appearance="subtle">
                                        {closeButton ? closeButton : formatMessage(m.cancel)}
                                    </Button>
                                </>
                            );
                        }
                    })()
                }
            </Modal.Footer>
        </Modal>
    );
};
